export const enum UnitType {
    Ward = 'Ward',
    Branch = 'Branch',
    District = 'District',
    Stake = 'Stake'
}
